<mat-card class="antim-autoware-card" [ngClass]="customCard">
  @if (title || subtitle) {
  <mat-card-header>
    <div class="antim-autoware-card-title">
      @if (title) {
      <mat-card-title>{{ title }}</mat-card-title>
      }
      @if (subtitle) {
      <mat-card-subtitle>{{ subtitle }}</mat-card-subtitle>
      }
    </div>
    <div class="button-view ">
      <!-- @if(addAddressFlag){
      <antim-autoware-button type="button" label="+ Add New" btnType="secondary" (clickEvent)='addNew()' />
      } -->
    </div>
  </mat-card-header>
  }
  <mat-card-content>
    <ng-content></ng-content>
  </mat-card-content>
</mat-card>